import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { setPageTitle } from '../../../redux/title/title.slice';
import {
  clearClients,
  getAdvisorClients,
  setSelectedClient
} from '../../../redux/clients/clients.slice';

import ClientSearchAndList from '../../../components/ui/newDesigns/ClientSearchAndList';

function AdvisorClients() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    clients = [],
    loadingClients,
    pageIndex = 0,
    totalPages = 1,
    totalCount = 0
  } = useSelector((state) => state.clients);

  useEffect(() => {
    dispatch(setPageTitle('Clients'));
  }, [dispatch]);

  // SEARCH
  const handleSearch = (payload) => {
    dispatch(clearClients());

    dispatch(
      getAdvisorClients({
        ...payload,
        pageIndex: 0
      })
    );
  };

  // PAGINATION
  const handlePageChange = (payload) => {
    dispatch(getAdvisorClients(payload));
  };

  // CLEAR
  const handleClear = () => {
    dispatch(clearClients());
  };

  // VIEW CLIENT
  const handleViewClient = (client) => {
    dispatch(
      setSelectedClient({
        id: client.id,
        name: client.name,
        id1: client.id1,
        id2: client.id2
      })
    );

    navigate(`/advisor/clients/${client.id}`);
  };

  return (
    <Box width="100%" mb={4}>
      <ClientSearchAndList
        clients={clients}
        loading={loadingClients}
        pageIndex={pageIndex}
        totalPages={totalPages}
        totalCount={totalCount}
        onSearch={handleSearch}
        onPageChange={handlePageChange}
        onClear={handleClear}
        onViewClient={handleViewClient}
      />
    </Box>
  );
}

export default AdvisorClients;
